import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.entries";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import wishlistQuery from '~/graphql/wishlist/wishlist.gql';
import deleteWishlistItemMutation from '~/graphql/wishlist/deleteWishlistItem.gql';
import isValidToken from '~/helpers/connection-helper';

function fetchDetailedWishlist(_x, _x2, _x3) {
  return _fetchDetailedWishlist.apply(this, arguments);
}

function _fetchDetailedWishlist() {
  _fetchDetailedWishlist = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(_ref, offset, limit) {
    var app, getters, locale, response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            app = _ref.app, getters = _ref.getters;

            if (!isValidToken()) {
              _context.next = 7;
              break;
            }

            locale = getters['i18n/locale'].iso;
            _context.next = 5;
            return app.apolloProvider.defaultClient.query({
              fetchPolicy: 'network-only',
              query: wishlistQuery,
              context: {
                headers: {
                  Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
                }
              },
              variables: {
                locale: locale,
                detailed: true,
                offset: offset,
                limit: limit
              }
            });

          case 5:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 7:
            return _context.abrupt("return", null);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchDetailedWishlist.apply(this, arguments);
}

function fetchWishlist(_x4) {
  return _fetchWishlist.apply(this, arguments);
}

function _fetchWishlist() {
  _fetchWishlist = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(context) {
    var locale, xhrUri, _ref2, data;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            locale = context.state.i18n.currentLocale;
            xhrUri = "".concat(context.state.sharedEnv.payload.web).concat(locale.market, "/").concat(locale.language, "/moodboard/getDefaultWishList");
            _context2.next = 4;
            return context.$axios.get(xhrUri, {
              withCredentials: true
            });

          case 4:
            _ref2 = _context2.sent;
            data = _ref2.data;
            return _context2.abrupt("return", {
              product: !('product' in data.wishlist) ? [] : data.wishlist.product
            });

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _fetchWishlist.apply(this, arguments);
}

function getWishlist(_x5) {
  return _getWishlist.apply(this, arguments);
}

function _getWishlist() {
  _getWishlist = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(context) {
    var data;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return fetchWishlist(context);

          case 2:
            data = _context3.sent;
            return _context3.abrupt("return", data);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getWishlist.apply(this, arguments);
}

function postItem(_x6, _x7) {
  return _postItem.apply(this, arguments);
}

function _postItem() {
  _postItem = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee4(context, payload) {
    var strData, i, xhrUri, _ref3, data;

    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            strData = '';

            for (i = 0; i < Object.entries(payload).length; i += 1) {
              if (strData) {
                strData += '&';
              }

              strData += "".concat(Object.entries(payload)[i][0], "=").concat(encodeURIComponent(Object.entries(payload)[i][1]));
            }

            xhrUri = "".concat(context.state.sharedEnv.payload.web, "moodboard/default/items");
            _context4.next = 5;
            return context.$axios(xhrUri, {
              method: 'POST',
              data: strData,
              headers: {
                Accept: 'application/json, text/plain',
                'Content-Type': 'application/x-www-form-urlencoded'
              },
              withCredentials: true
            });

          case 5:
            _ref3 = _context4.sent;
            data = _ref3.data;
            return _context4.abrupt("return", data);

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _postItem.apply(this, arguments);
}

function deleteItem(_x8, _x9) {
  return _deleteItem.apply(this, arguments);
}

function _deleteItem() {
  _deleteItem = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee5(context, payload) {
    var xhrUri, _ref4, data;

    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            xhrUri = "".concat(context.state.sharedEnv.payload.web, "moodboard/default/items/product/").concat(payload.reference);
            _context5.next = 3;
            return context.$axios.delete(xhrUri, {
              emulateJSON: true
            });

          case 3:
            _ref4 = _context5.sent;
            data = _ref4.data;
            return _context5.abrupt("return", data);

          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _deleteItem.apply(this, arguments);
}

function deleteWishlistItem(_x10, _x11) {
  return _deleteWishlistItem.apply(this, arguments);
}

function _deleteWishlistItem() {
  _deleteWishlistItem = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee6(context, reference) {
    var response;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (!isValidToken()) {
              _context6.next = 5;
              break;
            }

            _context6.next = 3;
            return context.app.apolloProvider.defaultClient.mutate({
              mutation: deleteWishlistItemMutation,
              context: {
                headers: {
                  Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
                }
              },
              variables: {
                reference: reference
              }
            });

          case 3:
            response = _context6.sent;
            return _context6.abrupt("return", response.data);

          case 5:
            return _context6.abrupt("return", null);

          case 6:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _deleteWishlistItem.apply(this, arguments);
}

export { getWishlist, postItem, deleteItem, deleteWishlistItem, fetchDetailedWishlist };